<!-- Header -->
@if (hss) {
  @if (hss.header.isFailedContinuity.text === "True") {
    <div class="header">
      <span
        [class.e-label]="enhanced"
        [class]="getChangedClass(hss.header.isFailedContinuity.didChange)"
      >
        {{ "SEQUENCE FAILED CONTINUITY".padStart(28, " ") }}
      </span>
    </div>
  }
  <div class="header">
    <span [class.e-label]="enhanced">SEQ</span>
    <span
      [class]="getChangedClass(hss.header.sequenceNumber.didChange)"
      [class.e-value]="enhanced"
      >{{
        hssBuilderService.toInt(hss.header.sequenceNumber.text).padStart(6, " ")
      }}</span
    >
    <span [class.e-label]="enhanced">{{ "BASE".padStart(11, " ") }}</span>
    <span
      [class.e-value]="enhanced"
      [class]="getChangedClass(hss.header.base.didChange)"
    >
      {{ hss.header.base.text.padEnd(13, " ") }}
    </span>

    @if (hss.header.isDeleted.text === "True") {
      <span
        [class.e-label]="enhanced"
        [class]="getChangedClass(hss.header.isDeleted.didChange)"
      >
        {{ "DLTD".padEnd(7, " ") }}
      </span>
    } @else {
      <span>{{ " ".padEnd(7, " ") }}</span>
    }

    <span
      [class.e-value]="enhanced"
      [class]="
        getChangedClass(hss.header.div.didChange || hss.header.acft.didChange)
      "
    >
      {{ hss!.header.div.text === "I" ? "INT" : "DOM" }}
      {{ hss!.header.acft.text.padEnd(16, " ") }}
    </span>
  </div>

  <!-- Name/emp num -->
  @if (hss!.header; as header) {
    <div class="header" [class.e-label]="enhanced">
      @if (header.position === "CA") {
        <span>CAPT</span>
      }
      @if (header.position === "FO") {
        <span>F/O</span>
      }
      @if (header.position === "FB") {
        <span>F/B</span>
      }
      @if (header.position === "FC") {
        <span>F/C</span>
      }
      <!-- Don't know if this is correct -->
      @if (header.position === "RC") {
        <span>R/C</span>
      }
      @if (header.isBlockedIOE.text === "True" && header.empNum.text === "0") {
        <span
          [class.e-value]="enhanced"
          [class]="getChangedClass(header.isBlockedIOE.didChange)"
        >
          {{ "BLOCKED IOE".padEnd(22, " ") }}
        </span>
      }
      @if (header.empNum.text === "0" && header.isBlockedIOE.text === "False") {
        <span
          [class.e-value]="enhanced"
          [class]="getChangedClass(header.name.didChange)"
        >
          OPEN
        </span>
        @if (
          globalService.isAdmin() &&
          header.empNum.didChange &&
          header.removeCode.text.trim() !== ""
        ) {
          <span class="opacity-5">(</span>
          <span class="clickable-code" (click)="code.toggle($event)">{{
            header.removeCode.text.trim()
          }}</span>
          <p-overlayPanel #code>
            <div>
              {{
                hssBuilderService.getCodeDescription(
                  header.removeCode.text,
                  "remove"
                )
              }}
            </div>
          </p-overlayPanel>
          <span class="opacity-5">)</span>
        }
      }
      @if (header.empNum.text !== "0") {
        <span
          [class.e-value]="enhanced"
          [class]="getChangedClass(header.name.didChange)"
        >
          {{ header.name.text.padEnd(22, " ") }}
        </span>
        <span [class.e-label]="enhanced">EMP NBR </span>
        <span
          [class.e-value]="enhanced"
          [class]="getChangedClass(hss.header.empNum.didChange)"
          >{{ hss.header.empNum.text }}</span
        >
        @if (
          header.isCheckAirman.text === "True" ||
          header.isSupervisor.text === "True"
        ) {
          <span
            [class.e-value]="enhanced"
            [class]="getChangedClass(header.empNum.didChange)"
          >
            SUP</span
          >
        }
        <!-- Add code -->
        @if (header.empNum.didChange && header.addCode.text.trim() !== "") {
          <span class="opacity-5"> (</span>
          <span class="clickable-code" (click)="code.toggle($event)">{{
            header.addCode.text
          }}</span>
          <p-overlayPanel #code>
            <div>
              {{
                hssBuilderService.getCodeDescription(header.addCode.text, "add")
              }}
            </div>
          </p-overlayPanel>
          <span class="opacity-5">)</span>
        }
      }
    </div>
  }
}
